import useRestList from "../_shared/hooks/useRestList";
import React, { useRef, useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import AppText from "../_shared/components/AppText";
import SideMenu from "../_shared/components/SideMenu";
import AppButton from "../_shared/components/AppButton";
import "./products.css";
import { getSubCategories } from "../../api";
import { Link } from "react-router-dom";
import { Col, Input, Row } from "antd";
import SearchIcon from "../../assets/images/icons/Icon-Cerca.png";
import BackIcon from "../_shared/components/BackIcon";

export default function Products(props) {
  const { setSplash } = props;
  useEffect(() => setSplash(false), []);

  const [categories] = useRestList("/categories");
  const [products] = useRestList("/products");

  const [mainCategory, setMainCategory] = useState();
  const [openSearch, setOpenSearch] = useState();

  const [data, setData] = useState();
  const [filter, setFilter] = useState();

  const [selectedProduct, setSelectedProduct] = useState();
  const inputRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {

    if (filter) {
      const filteredProducts = filterProducts(products, categories, filter)

      setData(filteredProducts)
    }
    else {
      setData([
        ...(products?.filter((prod) => prod?.pdfDetail) ?? []),
        ...(categories?.filter((prod) => prod?.pdfDetail) ?? []),
      ]);
    }

    //eslint-disable-next-line 
  }, [products, categories, filter]);


  function getMainCategories() {
    return categories
      ?.filter((main) => main?.parentCategory === undefined)
  }

  function getRootCategory() {
    // 
  }


  function filterProducts(products, categories, query) {

    const mainCategories = getMainCategories()

    console.log("mainCategories: ", mainCategories)

    const validProducts = products
      ?.filter?.((prod) => prod?.pdfDetail) ?? []

    const filteredProducts =
      validProducts?.filter?.(
        (prod) => {

          // console.log("PROD CATEGORY: ", prod)
          const mainCategory = mainCategories?.find(mainCategory => mainCategory?.id === prod?.category?.parentCategory)

          const mainCategoryNameIt = mainCategory?.name?.it ?? ""
          const mainCategoryNameEn = mainCategory?.name?.en ?? ""


          // console.log("mainCategoryNameIt: ", mainCategoryNameIt)

          const productTestString = `${prod?.name?.it}${prod?.name?.en}${prod?.category?.name?.it}${prod?.category?.name?.en}${mainCategoryNameIt}${mainCategoryNameEn}`.toLowerCase()

          return productTestString?.includes?.(query?.toLowerCase())
        }

      ) ?? []

    const validCategories = categories
      ?.filter((prod) => prod?.pdfDetail)

    const filteredCategories =
      validCategories?.filter(
        (prod) => {

          console.log("PROD: ", prod)
          const mainCategory = mainCategories?.find(mainCategory => mainCategory?.id === prod?.category?.parentCategory?.id)

          const mainCategoryNameIt = mainCategory?.name?.it ?? ""
          const mainCategoryNameEn = mainCategory?.name?.en ?? ""




          const categoryTestString = `${prod?.name?.it}${prod?.name?.en}${prod?.parentCategory?.name?.it}${prod?.parentCategory?.name?.en}${mainCategoryNameIt}${mainCategoryNameEn}`

          return categoryTestString?.includes?.(query.toLowerCase())
        }

      ) ?? []

    return [...filteredProducts, ...filteredCategories]
  }

  function navigateToSelectedItem(product) {
    navigate(
      products?.some((x) => x.id === product?.id)
        ? `/product/${product?.category?._id}/${product.id}`
        : `/products/slide/${product?.id}`
    );
  }
  function renderItem(x) {
    return (
      <div className="row">
        <div style={styles.pdfCard} onClick={() => navigateToSelectedItem(x)}>
          <img
            alt=""
            src={x?.pdfImageDetail}
            style={{ height: 240, width: 240, objectFit: "cover" }}
          ></img>
          <div>
            {x?.parentCategory && (
              <div style={styles.inline}>
                <AppText small bold>
                  {x?.parentCategory?.name?.it}&nbsp;/&nbsp;
                  {x?.parentCategory?.name?.en}
                </AppText>
              </div>
            )}
            {x?.category && (
              <div style={styles.inline}>
                <AppText small bold>
                  {x?.category?.name?.it}&nbsp;/&nbsp;
                  {x?.category?.name?.en}
                </AppText>
              </div>
            )}
            <div style={styles.inline}>
              <AppText small light>
                {x?.name?.it}&nbsp;{x?.name?.en && `/ ${x?.name?.en}`}
              </AppText>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderMainCategories() {
    return categories
      ?.filter((main) => main?.parentCategory === undefined)
      ?.sort((a, b) => a?.sortIndex - b?.sortIndex)
      ?.map((mainCat) => (
        <div style={{ minHeight: 35 }} className="fade-in-text">
          <AppButton onClick={() => setMainCategory(mainCat?.id)}>
            <div className="row">
              <AppText
                bold
                prod
                style={
                  mainCat?.id !== mainCategory
                    ? null
                    : { textDecoration: "underline" }
                }
              >
                {mainCat?.name?.it}
              </AppText>
              <AppText
                light
                prod
                style={
                  mainCat?.id !== mainCategory
                    ? null
                    : { textDecoration: "underline" }
                }
              >
                / {mainCat?.name?.en}
              </AppText>
            </div>
          </AppButton>
        </div>
      ));
  }

  function getPaddingSubCategory() {
    const index = categories
      ?.filter((main) => !main?.parentCategory)
      ?.findIndex((cat) => cat?.id === mainCategory);

    return index * 35;
  }

  function printSubCategories() {
    return (
      <div
        style={{ marginTop: getPaddingSubCategory() }}
        className="fade-in-text"
      >
        {console.log(
          categories?.filter(
            (main) => main?.parentCategory?.id === mainCategory
          )[0].parentCategory?.freeStanding
        )}
        {categories?.filter((main) => main?.parentCategory?.id === mainCategory)
          ?.length === 1 && (
            <Navigate
              to={
                categories?.filter(
                  (main) => main?.parentCategory?.id === mainCategory
                )[0].parentCategory?.freeStanding
                  ? `/products/list/${categories?.filter(
                    (main) => main?.parentCategory?.id === mainCategory
                  )[0].id
                  }`
                  : `/products/slide/${categories?.filter(
                    (main) => main?.parentCategory?.id === mainCategory
                  )[0].id
                  }`
              }
            />
          )}
        {categories
          ?.filter((main) => main?.parentCategory?.id === mainCategory)
          ?.sort((a, b) => a?.sortIndex - b?.sortIndex)
          ?.map((subCategory) => (
            <div style={{ minHeight: 30 }}>
              <Link
                to={
                  subCategory?.parentCategory?.freeStanding
                    ? `/products/list/${subCategory.id}`
                    : `/products/slide/${subCategory.id}`
                }
                style={{ color: "black" }}
                className="row"
              >
                <AppText prod bold>
                  {subCategory?.name?.it}
                </AppText>
                <AppText prod light>
                  / {subCategory?.name?.en}
                </AppText>
              </Link>
            </div>
          ))}
      </div>
    );
  }

  function renderMenu() {
    return (
      <div className="rootContent">
        <div style={styles.header}>
          <div className="row">
            <AppText bold>Prodotti</AppText>
            <AppText light>/ Products</AppText>
          </div>
          <div className="row">
            <img
              src={SearchIcon}
              alt=""
              style={{
                height: 20,
                width: 20,
                marginRight: 10,
                textDecorationLine: "underline",
              }}
            ></img>
            <div
              className="row"
              style={{
                borderBottomWidth: 1,
                borderBottomColor: "black",
                borderBottomStyle: "solid",
                height: 25,
                width: 250,
              }}
              onClick={() => setOpenSearch(true)}
            >
              <AppText small bold>
                cerca
              </AppText>
              <AppText small light>
                / search
              </AppText>
            </div>
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <Row>
            <Col style={{ marginTop: 20 }} span={13}>
              {renderMainCategories()}
            </Col>
            <Col style={{ marginTop: 20 }} span={11}>
              {mainCategory && printSubCategories()}
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  function renderProducts() {
    return (
      <div style={styles.flatList}>
        {data
          ?.sort(
            (a, b) =>
              a.parentCategory > b.parentCategory || a.category > b.category
          )
          ?.map((item) => renderItem(item))}
      </div>
    );
  }

  function renderSearch() {
    return (
      <div className="rootContent">
        <div
          className="row"
          style={{
            justifyContent: "space-between",
            minWidth: "89vw",
            marginBottom: 50,
          }}
        >
          <div
            className="row"
            style={{ display: "flex", alignItems: "center" }}
          >
            <BackIcon onClick={() => setOpenSearch(false)}></BackIcon>

            <AppText bold>Cerca prodotto</AppText>
            <AppText light>/ search products</AppText>
          </div>
          <div
            style={{
              borderBottomWidth: 1,
              borderBottomColor: "black",
              borderBottomStyle: "solid",
              height: 30,
              width: 400,
            }}
          >
            <Input
              ref={inputRef}
              bordered={false}
              placeholder={"🔍 nome prodotto / product name"}
              style={{ fontSize: 16, fontFamily: "Hurme" }}
              onChange={(e) => setFilter(e.target.value)}
              value={filter}
            ></Input>
          </div>
        </div>
        {renderProducts()}
      </div>
    );
  }

  return (
    <div className="rootMenu">
      <SideMenu></SideMenu>
      {openSearch ? renderSearch() : renderMenu()}
    </div>
  );
}
const styles = {
  header: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
  },

  root: {
    flexDirection: "row",
  },

  productCard: {
    marginBottom: 25,
    marginLeft: 5,
    width: "32%",
  },
  flatList: {
    marginLeft: 40,
    paddingBottom: 100,
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },

  inline: {
    display: "flex",
    flexDirection: "row",
  },
  pdfCard: {
    width: 280,
    marginRight: 30,
    height: 350,
    cursor: "pointer",
    // border: "0.1px solid black",
  },
};
